module.exports = {
  lang: {
    t1: `홈`,
    t2: `명함`,
    t3: `팔로우`,
    t4: `연락처`,
    t5: `메시지`,
    t6: `로그인`,
    t7: `등록`,
    t8: `글로벌 비즈니스 연결 새 플랫폼, 엔터프라이즈 디지털 마케팅의 새 터리토리`,
    t9: `WeMeet - 로그인 (휴대전화 번호)`,
    t10: `휴대전화 번호`,
    t11: `인증코드`,
    t12: `휴대전화 번호를 입력하세요`,
    t13: `인증코드를 입력하세요`,
    t14: `획득`,
    t15: `로그인`,
    t16: `올바른 형식의 휴대전화 번호를 입력하세요`,
    t17: `인증 코드가 발송되었습니다`,
    t18: `잘못된 인증 코드가 입력되었습니다. 확인 후 다시 입력해주세요.`,
    t19: `로그인에 성공했습니다`,
    t20: `귀하의 인증 코드는 (0)입니다. {1}분 이내에 사용해 주세요.`,
    t21: `취소`,
    t22: `확인`,
    t23: `유용한 팁`,
    t24: `WeMeet 계정 등록이 아직 완료되지 않았습니다. 지금 바로 행동하여 등록 프로세스를 완료하고 다양한 상호작용과 무한한 가능성을 즐기세요.`,
    t25: `가입 페이지로 이동`,
    t26: `WeMeet 이메일 로그인`,
    t27: `계정명`,
    t28: `이메일을 입력하세요`,
    t29: `비밀번호`,
    t30: `비밀번호를 입력하세요`,
    t31: `비밀번호를 잊으셨나요?`,
    t32: `로그인`,
    t33: `다른 로그인 방법`,
    t34: `이미 WeMeet 미니어처 앱에 등록하셨습니까? 지금 바로 사용하세요.`,
    t35: `로그인하기(휴대폰 번호)`,
    t36: `메일을 먼저 입력해 주세요.`,
    t37: `비밀번호를 먼저 입력해 주세요.`,
    t38: `이메일 형식이 올바르지 않습니다`,
    t39: `WeMeet 계정이 있으시면, 직접 로그인하실 수 있습니다`,
    t40: `로그인`,
    t41: `프로필 사진`,
    t42: `실제 프로필 사진을 업로드해 주세요`,
    t43: `성명`,
    t44: `이름`,
    t45: `성`,
    t46: `기관명`,
    t47: `귀하가 속한 기관의 이름을 입력해 주세요`,
    t48: `직함`,
    t49: `귀하가 속한 기관 내에서의 직위명을 입력해 주세요`,
    t50: `이메일`,
    t51: `이메일을 입력하세요`,
    t52: `휴대전화 번호`,
    t53: `휴대전화 번호를 입력하세요`,
    t54: `지역`,
    t55: `지역을 선택해 주세요`,
    t56: `구역`,
    t57: `시・도・구를 선택해 주세요`,
    t58: `주소`,
    t59: `주소를 입력해 주세요`,
    t60: `WeMeet 이용약관 및 개인정보취급방침을 읽고 동의합니다.`,
    t61: `이용약관`,
    t62: `개인정보취급방침`,
    t63: `계속`,
    t64: `사용자 계약서에 동의하는 체크를 먼저 해주세요`,
    t65: `이름을 입력해 주세요`,
    t66: `성을 입력하세요`,
    t67: `메일을 먼저 입력해주세요`,
    t68: `기관명을 먼저 입력해주세요`,
    t69: `이메일 형식이 올바르지 않습니다`,
    t70: `취소`,
    t71: `완료`,
    t72: `휴대폰 번호 확인`,
    t73: `휴대전화 번호`,
    t74: `인증코드`,
    t75: `인증코드를 입력하세요`,
    t76: `획득`,
    t77: `인증 건너뛰기`,
    t78: `제출`,
    t79: `인증되었습니다`,
    t80: `잘못된 인증 코드가 입력되었습니다. 확인 후 다시 입력해주세요.`,
    t81: `건너뛰었습니다`,
    t82: `유용한 팁`,
    t83: `입력하신 전화번호는 이미 WeMeet 계정으로 등록되어 있습니다. 다시 등록할 필요 없이 지금 로그인해주세요.`,
    t84: `로그인 페이지로 이동`,
    t85: `유용한 팁`,
    t86: `입력하신 이메일은 이미 WeMeet 계정으로 등록되어 있습니다. 다시 등록할 필요 없이 지금 로그인해주세요.`,
    t87: `로그인 페이지로 이동`,
    t88: `확인 링크가 발송되었습니다.`,
    t89: `메일함을 확인하고 링크를 클릭하여 가입을 완료해주세요.`,
    t90: `알겠습니다`,
    t91: `WeMeet에 오신 것을 환영합니다`,
    t92: `WeMeet에 오신 것을 환영합니다! 회원가입을 완료하시려면 버튼을 클릭해 주세요. 친절한 알림: 이 링크는 24시간 동안 유효하므로 가능한 빨리 조치해 주시기 바랍니다.`,
    t93: `가입 완료`,
    t94: `이메일이 활성화되었습니다. 비밀번호를 입력해주세요.`,
    t95: `비밀번호를 입력하세요`,
    t96: `비밀번호를 입력하세요`,
    t97: `비밀번호 확인`,
    t98: `비밀번호를 다시 입력해주세요`,
    t99: `대소문자, 숫자, 특수문자를 포함한 8~20자의 조합으로 입력해주세요`,
    t100: `비밀번호를 입력하세요`,
    t101: `비밀번호를 다시 입력해주세요`,
    t102: `비밀번호가 일치하지 않습니다`,
    t103: `회원가입이 완료되었습니다. 축하합니다.`,
    t104: `WeMeet에 로그인되었습니다. 이전 작업을 계속할 수 있습니다.`,
    t105: `경험을 계속하세요`,
    t106: `유용한 팁`,
    t107: `링크가 만료되었습니다. 다시 가져오려면 버튼을 클릭하세요.`,
    t108: `재전송`,
    t109: `이용약관`,
    t110: `개인정보취급방침`,
    t111: `비밀번호 재설정`,
    t112: `비밀번호를 재설정하고자 하는 계정을 입력해주세요`,
    t113: `계정명`,
    t114: `이메일을 입력하세요`,
    t115: `제출`,
    t116: `메일을 먼저 입력해 주세요.`,
    t117: `이메일 형식이 올바르지 않습니다`,
    t118: `이메일이 발송되었습니다`,
    t119: `이메일을 확인하시고, 링크를 클릭하여 비밀번호를 재설정해주세요.`,
    t120: `알겠습니다`,
    t121: `비밀번호 재설정 - WeMeet`,
    t122: `암호 재설정 요청이 확인되었으며, 시스템에서 임시 비밀번호 재설정 링크를 생성했습니다. 친절한 알림: 이 링크는 24시간 동안 유효하므로 가능한 빨리 조치해 주시기 바랍니다.`,
    t123: `비밀번호 재설정`,
    t124: `비밀번호 재설정에 성공했습니다`,
    t125: `WeMeet에 로그인되었습니다. 다시 오신 것을 환영합니다.`,
    t126: `홈페이지로 이동`,
    t127: `연락처`,
    t128: `새로운 연락처 요청`,
    t129: `승인하기`,
    t130: `무시하기`,
    t131: `승인됨`,
    t132: `무시됨`,
    t133: `다음`,
    t134: `팔로워가 있습니다`,
    t135: `메시지`,
    t136: `처리되지 않은 요청`,
    t137: `이름 또는 전화번호를 입력해주세요`,
    t138: `일치하는 내용이 없습니다`,
    t139: `더 이상 없습니다`,
    t140: `연락처 요청`,
    t141: `승인하기`,
    t142: `무시하기`,
    t143: `승인됨`,
    t144: `무시됨`,
    t145: `WeMeet AI 공간`,
    t146: `팔로우 중`,
    t147: `언팔로우됨`,
    t148: `vCard`,
    t149: `연결`,
    t150: `메시지를 보내다`,
    t151: `승인 대기 중`,
    t152: `연락처 삭제`,
    t153: `개인소개`,
    t154: `프로필`,
    t155: `유용한 팁`,
    t156: `연락처 요청이 접수되었습니다. 승인되면 자동으로 TA를 팔로우하게 됩니다. 또는 지금부터 TA를 팔로우하여 자세한 정보를 얻을 수도 있습니다.`,
    t157: `아직 팔로우하지 않음`,
    t158: `팔로우`,
    t159: `팔로우 중`,
    t160: `연락처 관계 해제`,
    t161: `연락처 관계를 해제한 후 상대방은 개인 정보를 볼 수 없지만 동시에 언팔로우되지는 않습니다.`,
    t162: `다시 생각해보세요`,
    t163: `연락처 삭제`,
    t164: `작업 성공`,
    t165: `WeMeet AI 어시스턴트`,
    t166: `질문을 입력해주세요`,
    t167: `보내기`,
    t168: `AI와의 상호 작용 내용이 정확하지 않을 수 있으며, 플랫폼의 관점不代表할 수 있습니다.`,
    t169: `WeMeet 비즈니스 카드`,
    t170: `다운로드`,
    t171: `비즈니스 카드 편집`,
    t172: `QR 코드 다운로드`,
    t173: `이미지가 생성되었습니다. 저장해주세요. QR코드를 스캔하여 연락처를 저장하세요.`,
    t174: `프로필 사진`,
    t175: `실제 프로필 사진을 업로드해 주세요`,
    t176: `성명`,
    t177: `이름`,
    t178: `성`,
    t179: `이름을 입력해주세요`,
    t180: `기관명`,
    t181: `귀하가 속한 기관의 이름을 입력해 주세요`,
    t182: `직함`,
    t183: `귀하가 속한 기관 내에서의 직위명을 입력해 주세요`,
    t184: `이메일`,
    t185: `이메일을 입력하세요`,
    t186: `휴대전화 번호`,
    t187: `휴대전화 번호를 입력하세요`,
    t188: `지역`,
    t189: `지역을 선택해 주세요`,
    t190: `구역`,
    t191: `시・도・구를 선택해 주세요`,
    t192: `주소`,
    t193: `주소를 입력해 주세요`,
    t194: `이름을 입력해 주세요`,
    t195: `성을 입력하세요`,
    t196: `메일을 먼저 입력해주세요`,
    t197: `기관명을 먼저 입력해주세요`,
    t198: `이메일 형식이 올바르지 않습니다`,
    t199: `채팅방`,
    t200: `사진 갤러리`,
    t201: `사진 찍기`,
    t202: `메시지를 입력해주세요`,
    t203: `보내기`,
    t204: `읽음`,
    t205: `미독`,
    t206: `회수 기한이 지났습니다`,
    t207: `취소`,
    t208: `사진 (sajin)`,
    t209: `앨범 (aelbeom)`,
    t210: `촬영 (chuyŏng)`,
    t211: `앨범에서 선택하기 (aelbeome seontaeghagi)`,
    t212: `취소`,
    t213: `사진 (sajin)`,
    t214: `초상화 (chosanghwa)`,
    t215: `미리보기 (miribogi)`,
    t216: `완료`,
    t217: `WeMeet AI 스페이스`,
    t218: `연락처`,
    t219: `저에게 연락해 주세요`,
    t220: `성명`,
    t221: `기관`,
    t222: `직위`,
    t223: `전화`,
    t224: `이메일`,
    t225: `지역`,
    t226: `구역`,
    t227: `주소`,
    t228: `이름을 입력해 주세요`,
    t229: `귀사의 기관명을 작성해 주세요`,
    t230: `귀하의 직책을 작성해 주세요`,
    t231: `전화번호를 입력하세요`,
    t232: `귀하의 이메일 주소를 작성해 주세요`,
    t233: `지역을 선택해 주세요`,
    t234: `시・도・구를 선택해 주세요`,
    t235: `주소를 입력해 주세요`,
    t236: `의도`,
    t237: `제품 구매`,
    t238: `에이전트 제품`,
    t239: `시장 협력`,
    t240: `기타`,
    t241: `이름을 입력해 주세요`,
    t242: `귀사의 기관명을 작성해 주세요`,
    t243: `귀하의 이메일 주소를 작성해 주세요`,
    t244: `이메일 형식이 올바르지 않습니다`,
    t245: `메시지가 제출되었습니다`,
    t246: `메시지를 남겨주세요`,
    t247: `문의 내용을 입력해주세요`,
    t248: `확인`,
    t249: `로그인 또는 회원가입 먼저 해주세요`,
    t250: `팔로워 수`,
    t251: `문의하기`,
    t252: `제품`,
    t253: `팀`,
    t254: `개요`,
    t255: `앨범`,
    t256: `자격`,
    t257: `등록자본금`,
    t258: `설립일`,
    t259: `등록 주소`,
    t260: `상류`,
    t261: `중류`,
    t262: `하류`,
    t263: `Industri terkait`,
    t264: `공정`,
    t265: `저장`,
    t266: `확인됨`,
    t267: `중국어`,
    t268: `영어`,
    t269: `프랑스어`,
    t270: `러시아어`,
    t271: `스페인어`,
    t272: `일본어`,
    t273: `한국어`,
    t274: `인도네시아어`,
    t275: `베트남어`,
    t276: `독일어`,
    t277: `터키어`,
    t278: `이탈리아어`,
    t279: `포르투갈어`,
    t280: `태국어`,
    t281: `말레이어`,
    t282: `아랍어`,
    t283: `아이디 또는 비밀번호가 올바르지 않습니다`,
    t284: `WeMeet 이용약관을 읽고 동의해주세요.`,
    t285: `관련 내용이 없습니다`,
    t286: `유형`,
    t287: `속성`,
    t288: `상세정보`,
    t289: `기타`,
    t290: `총 2개의 제품`,
    t291: `{1}님이 {2}의 WeMeet AI Space 방문을 초대합니다`,
    t292: `여기를 클릭하여 예제를 확인하거나 질문을 입력하세요:`,
    t293: `새로 고침`,
    t294: `아래 명함을 클릭하여 연락처를 추가하여 자세한 정보를 확인할 수도 있습니다:`,
    t295: `배우다`,
    t296: `WeMeet 디지털 회의`,
    t297: `WeMeet 디지털 전시`,
    t298: `WeMeet個人名刺とWeMeet AIスペース`,
    t299: `WeMeet 조직 회원이 되는 방법`,
    t300: `WeMeet 디지털 회의 서비스는 회의 생성 및 게시, 참가자 등록 관리, 전자 체크인, 회의 일정 관리, 회의 자료 공유, 실시간 대화, 게스트 상호 작용을 포함한 포괄적인 온라인 회의 솔루션을 제공합니다.`,
    t301: `WeMeet 디지털 전시, 전시 마이크로 공식 웹 사이트를 빠르게 구축하는 데 도움을 줍니다. 전시 업체 정보, 전시품 소개, 전시 생중계, 전시 등록, 행사 일정 등을 표시하여 참가 기업과 관객이 전시 세부 정보를 쉽게 이해할 수 있습니다. WeMeet 디지털 전시 기능을 사용하려면 먼저 기관 입주를 완료하십시오. "내"를 클릭하고 "서비스 센터"로 스크롤하여 "기관 입주"를 클릭하고 안내에 따라 입주 절차를 완료하십시오.`,
    t302: `WeMeet 개인 사용자는 WeChat ID, 전화 번호를 승인하고 플랫폼 등록을 완료하여 개인 디지털 명함을 얻을 수 있으며 개인 AI 라운지(개인 이력서, 업데이트, 사진, 문서 등 포함)를 유지할 수 있습니다.`,
    t303: `미니 프로그램의 하단 메뉴 바에서 "내" 옵션을 클릭하여 개인 명함 페이지를 업데이트하고 개인 홈페이지를 개선합니다.`,
    t304: `대문자, 소문자, 숫자, 구두점이 혼합된 길이가 8-20 자인 조합입니다.`,
    t305: `제품 이름 입력`,
    t306: `더 이상 없음`,
    t307: `오른쪽 상단을 클릭하십시오`,
    t308: `선호하는 공유 방법을 선택하십시오`,
    t309: `이해했습니다`,
    t310: `먼저 등록 및 로그인을 완료하십시오`,
    t311: `더 알아보기`,
    t312: `관련 제품`,
    t313: `방문해 주셔서 감사합니다`,
    t314: `로그아웃`,
    t315: `팔로우한 조직`,
    t316: `이전`,
    t317: `다음`,
    t318: `없음`,
    t319: `{1}가 {2}을(를) 방문하도록 초대합니다`,
    t320: `AI 라운지는 현재 언어를 유지하지 않았습니다`,
    t321: `AI 라운지가 현재 언어로 전환되었습니다`,
    t322: `링크가 활성화되었습니다`,
    t323: `네트워크가 혼잡합니다. 나중에 다시 시도하십시오`,
    t324: `제품 세부 정보가 현재 언어로 전환되었습니다`,
    t325: `제품 세부 정보는 현재이 언어로 유지되지 않습니다`,
    t326: `안녕하세요, 저는 WeMeet 지능형 AI 어시스턴트입니다. 언제든지 세심한 서비스를 제공할 준비가 되어 있습니다! 무엇을 도와 드릴까요?`,
    t327: `이름을 입력하십시오`,
    t328: `관련 연락처 정보를 찾았습니다. 아래의 연락처 카드를 확인해주세요.`,
    t329: `첨부 파일`,
    t330: `관련 연락처 정보를 찾지 못했습니다.`,
    t331: `아래의 담당 동료에게 귀하의 문의를 전달했습니다. 명함을 클릭하여 즉시 연락할 수 있습니다.`,
    t332: `전시회`,
    t333: `입력해 주세요`,
    t334: `사용자`,
    t335: `더 이상 없음`,
    t336: `새로 고침 성공`,
    t337: `로딩 중`,
    t338: `새로 고침하려면 릴리스`,
  },
};
